import { render } from "./SiFooter.vue?vue&type=template&id=0ffda953&scoped=true"
import script from "./SiFooter.vue?vue&type=script&lang=js"
export * from "./SiFooter.vue?vue&type=script&lang=js"

import "./SiFooter.vue?vue&type=style&index=0&id=0ffda953&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffda953"]])

export default __exports__